import { gql } from 'graphql-request';

export const ACCOUNT = gql`
  mutation GetCustomerAccessTokenCreate($email: String!, $pass: String!) {
    customerAccessTokenCreate(input: { email: $email, password: $pass }) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        field
        message
      }
    }
  }
`;

export const CUSTOMER = gql`
  query getCustomer($token: String!) {
    customer(customerAccessToken: $token) {
      id
      firstName
      lastName
      acceptsMarketing
      email
      phone
      addresses(first: 5) {
        edges {
          node {
            id
            address1
            address2
            city
            company
            countryCodeV2
            firstName
            lastName
            id
            phone
            province
            provinceCode
            zip
          }
        }
      }
    }
  }
`;
